import React from 'react'

function TechSelectionVAS() {
  return (
    <embed src="\pdfs\E1.5.4_VA-S_Swivel_displacement_outlet_05.2010-2-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionVAS